// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` 
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease;
  }
  
  .modal-content {
    background-color: #fff;
    padding: 30px;
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    animation: slideIn 0.3s ease-out;
  }
  
  .modal-content h2 {
    margin-top: 0;
    margin-bottom: 24px;
    font-size: 22px;
    color: #111827;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  }
  
  .form-group input,
  .form-group textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 16px;
    box-sizing: border-box; 
  }
  
  .status-toggle {
    display: flex;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    overflow: hidden;
  }
  
  .status-toggle button {
    flex: 1 1;
    padding: 12px;
    border: none;
    background-color: #f9fafb;
    cursor: pointer;
    font-weight: 500;
    color: #6b7280;
    transition: all 0.2s;
  }
  
  .status-toggle button.active {
    background-color: #F97316;  
    color: #fff;
  }
  
  
  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 30px;
  }
  
  .btn-cancel, .btn-save {
    padding: 10px 20px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
  }
  
  .btn-cancel {
    background-color: #fff;
    border: 1px solid #d1d5db;
    color: #374151;
  }
  .btn-cancel:hover {
    background-color: #f9fafb;
  }
  
  .btn-save {
    background-color: #F97316;
    border: 1px solid #F97316;
    color: #fff;
  }
  .btn-save:disabled {
    background-color: #fb923c;
    cursor: not-allowed;
  }
   
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
  
  @keyframes slideIn { from { transform: translateY(-30px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }`, "",{"version":3,"sources":["webpack://./src/compoonents/EditVendorModal/EditVendorModal.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,yCAAyC;IACzC,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;;EAGA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;AAEF;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;EAEE,qBAAqB,OAAO,4BAA4B,EAAE,UAAU,EAAE,EAAE,KAAK,wBAAwB,EAAE,UAAU,EAAE,EAAE","sourcesContent":[" \n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    animation: fadeIn 0.3s ease;\n  }\n  \n  .modal-content {\n    background-color: #fff;\n    padding: 30px;\n    border-radius: 12px;\n    width: 90%;\n    max-width: 500px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    animation: slideIn 0.3s ease-out;\n  }\n  \n  .modal-content h2 {\n    margin-top: 0;\n    margin-bottom: 24px;\n    font-size: 22px;\n    color: #111827;\n  }\n  \n  .form-group {\n    margin-bottom: 20px;\n  }\n  \n  .form-group label {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #374151;\n  }\n  \n  .form-group input,\n  .form-group textarea {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-size: 16px;\n    box-sizing: border-box; \n  }\n  \n  .status-toggle {\n    display: flex;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    overflow: hidden;\n  }\n  \n  .status-toggle button {\n    flex: 1;\n    padding: 12px;\n    border: none;\n    background-color: #f9fafb;\n    cursor: pointer;\n    font-weight: 500;\n    color: #6b7280;\n    transition: all 0.2s;\n  }\n  \n  .status-toggle button.active {\n    background-color: #F97316;  \n    color: #fff;\n  }\n  \n  \n  .modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 30px;\n  }\n  \n  .btn-cancel, .btn-save {\n    padding: 10px 20px;\n    border-radius: 6px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n  }\n  \n  .btn-cancel {\n    background-color: #fff;\n    border: 1px solid #d1d5db;\n    color: #374151;\n  }\n  .btn-cancel:hover {\n    background-color: #f9fafb;\n  }\n  \n  .btn-save {\n    background-color: #F97316;\n    border: 1px solid #F97316;\n    color: #fff;\n  }\n  .btn-save:disabled {\n    background-color: #fb923c;\n    cursor: not-allowed;\n  }\n   \n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n  \n  @keyframes slideIn { from { transform: translateY(-30px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
